import { createContext } from "react";

import { ConditionHelper } from "./ConditionHelper.ts";

export const ConditionContext = createContext<ConditionHelper>(
  {} as ConditionHelper
);
